import React from 'react';
import * as XLSX from 'xlsx';

export const ExcelButton = ({ rows, fileName = 'export.xlsx', sheetName = 'Sheet1' }) => {
  const handleDownload = () => {
    const data = typeof rows === 'function' ? rows() : (rows || []);
    if (!data || data.length === 0) return;
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(data);
    XLSX.utils.book_append_sheet(wb, ws, sheetName);
    XLSX.writeFile(wb, fileName);
  };

  return (
    <button
      type="button"
      className="mainButton"
      onClick={handleDownload}
      title="Download as Excel"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        background: '#1d6f42',
        whiteSpace: 'nowrap',
      }}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
        <polyline points="14 2 14 8 20 8"></polyline>
        <line x1="8" y1="13" x2="16" y2="13"></line>
        <line x1="8" y1="17" x2="16" y2="17"></line>
      </svg>
      Download Excel
    </button>
  );
};
